<template>
    <header>
        <div class="header-top bg-light">
            <ul class="info-links">
                <li><a href="javascript:void(0)"><i class="fas fa-envelope-open"></i> <span class="detail">&#105;&#110;&#102;&#111;&#64;&#99;&#114;&#121;&#111;&#46;&#104;&#111;&#115;&#116;</span></a>
                </li>
                <li><a href="javascript:void(0)"><i class="fas fa-phone"></i><span
                        class="detail">08644 989204</span></a></li>
            </ul>
            <ul class="info-links float-right">
                <li><a href="https://my.cryo.host/supporttickets.php"><i class="fas fa-life-ring"></i>Support</a></li>
                <li><a href="https://my.cryo.host/cart.php"><i class="fas fa-box-open"></i>View Cart</a></li>
            </ul>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <a @click="goHome()" class="navbar-brand" href="javascript:void(0)">
                <img :src="asset('/img/logo.svg')"/>
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">

                    <li class="nav-item" v-for="route in routes" v-bind:key="route.path">
                        <router-link tag="a" class="nav-link" class-active="active" :to="route.path" exact>{{
                            route.title }}
                        </router-link>
                    </li>

                    <li class="nav-item nav-cta">
                        <a class="nav-link" href="https://my.cryo.host">Login</a>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
    export default {
        name: "NavigationBarComponent",
        methods: {
            goHome() {
                this.$router.push('/');
            },
            pushRoute(route) {
                if (!route.meta) return;

                if (!route.meta['showInNav']) return;

                this.routes.push({
                    name: route.name,
                    path: route.path,
                    title: route.meta['title']
                })
            }
        },
        created() {
            this.$router.options.routes.forEach(route => {
                this.pushRoute(route);

                if (route.children && route.children.length > 0) {
                    route.children.forEach(child => {
                        this.pushRoute(child)
                    })
                }

            })
        },
        data() {
            return {
                routes: []
            }
        }
    }
</script>

<style lang="scss">
    header {
        position: relative;
        z-index: 2147483637;

        .header-top {
            border-bottom-width: 1px;
            border-bottom-style: solid;
            border-bottom-color: #ececec;
            padding: 15px 20px 10px;

            ul.info-links {
                display: inline-block;
                padding: 0;
                margin-bottom: 0;

                li {
                    list-style: none;
                    display: inline-block;
                    padding-right: 15px;

                    a {
                        color: #00000080;
                        font-family: "ProximaRegular", "Nunito", sans-serif;
                        font-weight: bold;

                        &:hover {
                            text-decoration: none;
                            color: #444;
                        }

                        i {
                            padding-right: 5px

                        }
                    }
                }
            }
        }

        .navbar {
            font-family: "ProximaRegular", "Nunito", sans-serif;
            font-weight: bold;
            height: 70px;
            padding: 0 20px;

            .navbar-brand {
                height: 100%;
                box-sizing: border-box;
                padding: 20px 0;
                transition: transform 100ms linear;

                img {
                    height: 100%
                }

                &:hover {
                    filter: brightness(120%);
                    transform: scale(1.005);
                }
            }

            .nav-item.nav-cta {
                a {
                    background-color: #0e324d;
                    color: white;
                    padding: 5px 25px;
                    border-radius: 50px;
                    margin-top: 3px;
                    margin-left: 20px;
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        .info-links li a .detail {
            display: none;
        }
    }

    @media screen and (max-width: 990px) {
        header .navbar .nav-item.nav-cta .nav-link {
            margin-left: 0
        }
    }
</style>